import React from 'react'
import styles from './watchlists-overview.module.scss'
import { MAX_WATCHLISTS_LENGTH } from 'constants/watchlists'
import { Watchlist } from 'types/global'
import { AppState } from 'redux/reducers'
import BtnPrimary from 'components/generic/BtnPrimary'
import { useSelector, useDispatch } from 'react-redux'
import { PLAYER_SEARCH_HREF, TABLET_BREAKPOINT } from 'constants/global'
import useWindowSize from 'hooks/use-windowSize'
import i18n from 'constants/strings'
import { ReactComponent as IconWatchlist } from 'images/icons/icn_large_watchlist.svg'
import WatchlistCard from './WatchlistCard'
import cx from 'classnames'
import { ReactComponent as IconPlus } from 'images/icons/icn_plus.svg'
import LoadingSpinnerWithContainer from 'components/generic/LoadingSpinnerWithContainer'
import EmptyWatchlistPanel from './common/EmptyWatchlistPanel'
import { useModalDispatch } from 'hooks/use-modal'
import { WatchlistsModalId, WatchlistsModalsState } from 'constants/modals'

const WatchlistsOverview: React.FC = () => {
  const { modalDispatch: createModalDispatch, modalActions: createModalActions } = useModalDispatch<
    WatchlistsModalsState,
    WatchlistsModalId.CREATE_WATCHLIST
  >(WatchlistsModalId.CREATE_WATCHLIST)
  const playerWatchlists: { [key: string]: Watchlist } = useSelector(
    (state: AppState) => state.watchlists.watchlists
  )
  const loading: boolean = useSelector((state: AppState) => state.watchlists.loadingWatchlists)
  const watchlists = Object.values(playerWatchlists)
  const windowWidth = useWindowSize().width
  const isMobile = windowWidth < TABLET_BREAKPOINT
  const hasWatchlists = watchlists.length > 0

  const handleClick = () => {
    createModalDispatch(createModalActions.openModal())
  }

  if (loading) return <LoadingSpinnerWithContainer fullScreen />

  return (
    <>
      <header className={styles.header}>
        <h1>{i18n.t('strWatchlists.overview.title')}</h1>
        {hasWatchlists && !isMobile && (
          <BtnPrimary onClick={handleClick} className={styles.createBtnDesktop} border={false}>
            <IconPlus aria-hidden /> {i18n.t('strWatchlists.overview.createBtn')}
          </BtnPrimary>
        )}
      </header>
      <p className={styles.subtitle}>
        {i18n.t('strWatchlists.overview.subtitle', {
          count: watchlists.length,
          max: MAX_WATCHLISTS_LENGTH,
        })}
      </p>
      {hasWatchlists && isMobile && (
        <BtnPrimary onClick={handleClick} className={cx(styles.createBtnMobile)} size='small'>
          {i18n.t('strWatchlists.overview.createBtn')}
        </BtnPrimary>
      )}

      {hasWatchlists ? (
        <ul className={styles.list}>
          {watchlists.map(({ id, name, playerIds, stats }) => {
            return (
              <li className={styles.card} key={id}>
                <WatchlistCard
                  id={id}
                  name={name}
                  playerCount={playerIds.length}
                  wtnSinglesAvg={stats.avgSinglesWtn}
                />
              </li>
            )
          })}
        </ul>
      ) : (
        <EmptyWatchlistPanel
          icon={<IconWatchlist aria-hidden />}
          title={i18n.t('strWatchlists.overview.panelEmpty.title')}
          btnUrl={PLAYER_SEARCH_HREF}
        />
      )}
    </>
  )
}

export default WatchlistsOverview
